<template>
    <div class="">
        <div class="loading" v-if="!factor.isLoaded">
            در حال بارگذاری...
        </div>
        <div class="factor-list" v-else-if="factor.cards.length>0">
            <div v-for="factor in factor.cards" :key="factor.id"
            :class="['factor', factor.status_tahvil=='do'?'resive':(factor.status=='do'?'waitForMe':'dont')]">
                <h3>
                    خرید
                    {{ factor.package_name }}
                </h3>
                <small>
                    {{ factor.package_description }}
                </small>
                <small>
                    تعداد : 
                    {{ factor.package_count }}
                    عدد
                </small>
                <p>
                    {{ formatPrice(factor.package_price) }}
                </p>
                <strong v-if="factor.factor">
                    رسید پرداخت : {{ factor.factor }}
                </strong>
                <small>
                    ارسال به : {{ factor.address }}
                </small>
                <a class="bt" v-if="factor.status=='dont'" @click="pay(factor.package_id,factor.id)">
                    پرداخت سفارش
                </a>
                <small>
                    وضعیت : {{ factor.status_tahvil=='do'?'ارسال شد':(factor.status=='do'?'در حال ارسال':'عدم پرداخت') }}
                </small>
                <small>{{ moment(factor.created_at).format('jYYYY/jMM/jDD') }}</small>
            </div>
            <div ref="el" v-if="factor.hasMore"></div>
        </div>
    </div>
</template>
<script setup>
    import { useTemplateRef } from 'vue'
    import moment from 'moment-jalaali'
    import { useUserStore } from '@/stores/user'
    import { useAlertStore } from '@/stores/alert'
    import { polling } from '@/composables/polling'
    import { useFactorStore } from '@/stores/factor'
    import { useInfiniteScroll } from '@vueuse/core'
    import { isDefrentFactorData } from '@/composables/polling/isDefrentFactorData';
    const user = useUserStore()
    const alertStore = useAlertStore()
    const factor = useFactorStore()
    const el = useTemplateRef('el')
    const formatPrice = (price) => {
        if (!price && price !== 0) return '-'
        return new Intl.NumberFormat('fa-IR').format(price) + ' تومان'
    };
    polling( 
        async () => await factor.fetchFactors(factor.cards.length > 0 ? factor.cards.length : 10 , 0 , false),
        {
            oldData:factor.cards??[],
            intervalMs: 6000,
            isDifferent: (newData) => isDefrentFactorData(factor.cards,newData),
            onChange: (allNew) => {
                if(isDefrentFactorData(factor && factor.cards?factor.cards:[],allNew?allNew:[])){
                    if(factor.cards.length<allNew.length){
                        alertStore.type=true
                        alertStore.msg='تغییرات جدید!'
                    }
                    factor.cards = allNew?allNew:[]
                }
            }
        }
    )
    useInfiniteScroll(
        el, 
        async () => {
            await factor.fetchFactors(10,factor.cards.length,true) 
        } , { 
            distance: 50,
            canLoadMore: () => { 
                return factor.hasMore
            } 
        }
    )
    const pay = (pId,fId) => {
        return factor.pay(pId,fId,user)
    }
</script>
<style scoped>
    .resive{
        background-color: green;
    }
    .waitForMe{
        background-color: yellow;
    }
    .dont{
        background-color: red;
    }
    .factor-list {
        direction: rtl;
        text-align: center;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        gap: 9px;
        align-items: center;
    }
    .factor {
        color: #0e154b;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: center;
        gap: 10px;
        padding: 15px;
        border-radius: 10px;
        opacity: 0.7;
    }
    h3,p{
        margin: 0px;
    }
    .bt{
        text-align: center;
        border-radius: 10px;
        color: white;
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        background-color: green;
    }
</style>